import { Engineer } from '../../organisation/models/engineer'
import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({
  nominated: { format: Engineer.create },
  nominator: { format: Engineer.create },
  created_at: { property: 'created', type: 'date' },
})
export class JobSignatureNomination extends Mappable {
  id!: number
  nominated?: Engineer
  nominator?: Engineer
  created!: Date

  static create<Data>(attrs: Data) {
    return new JobSignatureNomination().map(attrs)
  }
}
